import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

export default function PointDetailOpenStatus(): {
  pointDetailOpen: ComputedRef<boolean>
  setPointDetailOpen: (bool?: boolean) => void
} {
  const store = useStore()
  const pointDetailOpen: ComputedRef<boolean> = computed((): boolean => {
    return store.state.pointDetailOpen
  })
  const setPointDetailOpen = (bool =false) => {
    store.commit('setPointDetailOpen', bool)
  }
  return {
    pointDetailOpen,
    setPointDetailOpen
  }
}
